import React from 'react'
import AcquireWebComponent from '../../framework/MaterialUI'
import { Row, Col, FullRow } from '../../framework/Grid/'
import { splitNumber, getDemographicText, pdfReportHeaderDataUri, addPdfFooter, getTextSize, getUrlParameterByName }
	from '../../../utils/utility'
import SiteDateSelector from '../SiteDateSelector'
import NewNavigator from '../newNavigator';
import TopAttributeListSection from '../page/TopAttributeList'
import PopularPageListSection from '../PopularPageList'
import InsightNavigation from '../InsightNav'
import InsightBreadcrumb from '../InsightBreadcrumb'
import FrequencyVisitorList from '../page/FrequencyVisitorList'
import BasicTierUpgradeInform from './BasicTierUpgradeInform'
import ServiceContact from '../ServiceContact';

import DeviceInsights from './Device';
import Checkbox from "material-ui/Checkbox";
import SideBar from "./SideBar";
import OverviewInsights from "./OverviewInsights";
import { Dialog } from 'material-ui'
import {URL} from 'url-polyfill/url'
import { map, orderBy, isEmpty, isNil, findIndex } from 'lodash'
import moment from 'moment'
import "../insights.css"
import isUndefined from 'lodash/isUndefined';
import reduce from 'lodash/reduce';
import sortBy from 'lodash/sortBy';
import queryString from "querystring";
import MostPopularPageInsights from './MostPopularPage'
import downloadAsPdf from './createPDF';
const pdfConverter = require('jspdf')
const html2canvas = require('html2canvas')
import createCsvFile from './createCSV';

class WebsiteVisits extends AcquireWebComponent {
	constructor(props) {
		super(props)
    const granularity = window.localStorage.getItem('__granularity__');

		this.state = {
			clientWidth: 0,
			showLoadingDialog: false,
			showUpgradeInfoDialog: false,
			showContactDialog: false,
			showDownloadDialog: false,
			disabledBtnDownload: false,
			onCsvReportDownload: false,
			pdfCreating: false,
			granularity: granularity || 'scale',
		}
		if (props.client_info){
			if (parseInt(props.client_info.subscriptionTierId, 10) < 3) {
				this.state = {
					clientWidth: 0,
					showLoadingDialog: false,
					showUpgradeInfoDialog: true,
					showContactDialog: false
				}
			}
		}
		const cid = getUrlParameterByName("cid");
    if (cid) {
      this.props.selectClient(parseInt(cid, 10));
		}
		if (props.client_info && props.client_info.id !== undefined) {
			this.props.getClientTags(props.client_info.id);
		}
		if (this.props.setGranularity) {
			this.props.setGranularity(granularity);
		}
	}

	componentWillReceiveProps(nextProps, preProps) {
		const nav = getUrlParameterByName('nav') || 'overview';
		const popUrl = getUrlParameterByName('pop_url');
		const reportType = nextProps.reportType;
		const client_info = nextProps.client_info;
		const preClientInfo = this.props.client_info || {};
		if (client_info && client_info.id !== preClientInfo.id) {
			this.props.getClientTags(client_info.id);
		}
		if (nextProps.selected_client !== this.props.selected_client) {
			if (nextProps.selected_client > 1) {
				this.props.getClientSites(nextProps.selected_client)
				this.props.getClientInfo(nextProps.selected_client);
				let url = "/insights/" + this.props.reportType + "?cid="+nextProps.selected_client+"&nav="+nav;
				if (popUrl) {
					url += `&pop_url=${encodeURIComponent(popUrl)}`;
				}
				this.props.history.push(url);
			}
			if (popUrl && nav === "pop") {
				this.props.getClientSites(nextProps.selected_client)
				this.props.getClientInfo(nextProps.selected_client);
				let url = "/insights/" + this.props.reportType + "?cid="+nextProps.selected_client+"&nav="+nav + "&pop_url="+ encodeURIComponent(popUrl);
				this.props.history.push(url);
			}
		}
		if ((nextProps.websiteId !== this.props.websiteId) ||
				(nextProps.dayRange !== this.props.dayRange) ||
				(nextProps.granularity !== this.props.granularity) ||
				(this.nav !== nav) ||
				(this.popUrl !== popUrl) ||
				(nextProps.location.pathname !== this.props.location.pathname) ||
				(nextProps.location.hash !== this.props.location.hash)) {
			this.nav = nav;
			this.popUrl = popUrl;
			if (nextProps.websiteId && nextProps.dayRange) {
				const { kindOfReport } = nextProps;
				this.props.clearAllStats()
				const url = new URL(window.location.href)
				const page = url.searchParams.get("p")
				if ((nav && (nav === "device" || nav === "overview")) || (reportType === 'business' && nav !== 'fir')) {
					this.props.getStatsByDeviceType(nextProps.websiteId, nextProps.dayRange, this.props.reportType, popUrl);
					this.props.getStatsByDeviceModel(nextProps.websiteId, nextProps.dayRange, this.props.reportType);
					this.props.getStatsByOsType(nextProps.websiteId, nextProps.dayRange, this.props.reportType);
				}
				if (isUndefined(kindOfReport) && nav !== 'fir') {
					//this.props.getStatsByPrimaryDevices(nextProps.websiteId, nextProps.dayRange, page)
					this.props.getStatsByTime(nextProps.websiteId, nextProps.dayRange, page || popUrl, this.props.reportType)
					!popUrl &&  this.props.getStatsByPopularPages(nextProps.websiteId, nextProps.dayRange, this.props.reportType)
					this.props.getStatsByRegionalTraffic(nextProps.websiteId, nextProps.dayRange, page || popUrl, this.props.reportType)
					this.props.getStatsByTimeOfDay(nextProps.websiteId, nextProps.dayRange, page || popUrl, this.props.reportType)
					reportType === 'business' && this.props.getStatsByDemographic(nextProps.websiteId, nextProps.dayRange, page || popUrl,
						this.props.reportType, nextProps.granularity)
					this.props.getDomesticVisits(nextProps.websiteId, nextProps.dayRange, this.props.reportType, page || popUrl);
					this.props.getStates(nextProps.websiteId, nextProps.dayRange, popUrl, this.props.reportType);

					if (this.props.reportType && nav === 'overview') {
						this.props.getDomesticBusinessStats(nextProps.websiteId, nextProps.granularity, nextProps.dayRange);
					}
				}
				if (kindOfReport === "map"){
					this.props.getHeatMapData(nextProps.websiteId, nextProps.dayRange, page || popUrl, this.props.reportType);
				}
				if (kindOfReport === "popular"){
					this.props.getStatsByPopularPages(nextProps.websiteId, nextProps.dayRange, this.props.reportType);
				}
				if (kindOfReport === "top"){
					this.props.getStatsTopAttributes(nextProps.websiteId, nextProps.dayRange, page, undefined, nextProps.granularity);
				}
				if (kindOfReport === "frequents" || nav === 'fir') {
					this.props.getTop20FrequencyBusiness(nextProps.websiteId, nextProps.dayRange);
				}
			}
		}
		if (nextProps.client_info && nextProps.client_info !== this.props.client_info){
			if (parseInt(nextProps.client_info.subscriptionTierId, 10) < 3) {
				this.setState({
					showUpgradeInfoDialog: true,
				})
			} else if (this.state.showUpgradeInfoDialog) {
				this.setState({ showUpgradeInfoDialog: false });
			}
		}

	}

	componentDidMount() {
		const urlParams = queryString.parse(this.props.location.search);
		const nav = getUrlParameterByName('nav') || 'overview';
		const popUrl = getUrlParameterByName('pop_url');
		this.updateDimensions();
		/*
		if (this.props.selected_client && this.props.selected_client > 1) {
			this.props.getClientSites(this.props.selected_client);
		}*/
		window.addEventListener("resize", this.updateDimensions.bind(this));
		const { kindOfReport, dayRange, websiteId, reportType, client_info } = this.props;
		const page = getUrlParameterByName("p")
		if (client_info) {
			if (parseInt(client_info.subscriptionTierId, 10) < 3) {
				this.setState({
					showUpgradeInfoDialog: true,
				})
			}
		}

		if (this.props.websiteId && this.props.dayRange) {
			const { kindOfReport, dayRange, websiteId, reportType, granularity } = this.props;
			this.props.clearAllStats()
			const url = new URL(window.location.href)
			const page = url.searchParams.get("p")
			if (nav === "device" || nav === "overview" || (reportType === 'business' && nav !== 'fir')) {
				this.props.getStatsByDeviceType(websiteId, dayRange, reportType, popUrl);
				this.props.getStatsByDeviceModel(websiteId, dayRange, reportType)
				this.props.getStatsByOsType(websiteId, dayRange, reportType)
			}
			if (isUndefined(kindOfReport) && nav !== 'fir') {
				//this.props.getStatsByPrimaryDevices(nextProps.websiteId, nextProps.dayRange, page)
				this.props.getStatsByTime(websiteId, dayRange, page || popUrl, reportType)
				!popUrl && this.props.getStatsByPopularPages(websiteId, dayRange, reportType)
				this.props.getStatsByRegionalTraffic(websiteId, dayRange, page || popUrl, reportType)
				this.props.getStatsByTimeOfDay(websiteId, dayRange, page || popUrl, reportType)
				reportType === 'business' && this.props.getStatsByDemographic(websiteId, dayRange, page || popUrl,
					reportType, this.props.granularity)
				this.props.getDomesticVisits(websiteId, dayRange, reportType, page);
				this.props.getStates(websiteId, dayRange, popUrl, reportType);
				if (this.props.reportType === "business") {
					this.props.getDomesticBusinessStats(websiteId, this.props.granularity, dayRange);
				}
			}
			if (kindOfReport === "map"){
				this.props.getHeatMapData(websiteId, dayRange, page || popUrl, reportType);
			}
			if (kindOfReport === "popular"){
				this.props.getStatsByPopularPages(websiteId, dayRange, reportType);
			}
			if (kindOfReport === "top" || urlParams.type === 'additional-demographics'){
				this.props.getStatsTopAttributes(websiteId, dayRange, page, undefined, this.props.granularity);
			}
			if (kindOfReport === "frequents" || nav === 'fir') {
				this.props.getTop20FrequencyBusiness(websiteId, dayRange);
			}
		} else {
			if (kindOfReport === "map"){
				this.props.getHeatMapData(websiteId, dayRange, page || popUrl, reportType);
			}
		}
	}

	componentWillUnmount() {
		window.removeEventListener("resize", this.updateDimensions);
	}

	updateDimensions() {
		let width = (document.getElementsByClassName('website-visits-content')[0].clientWidth * 0.8 ) / 2;
		this.setState({clientWidth: width});
	}

	handleDownload(e) {
    e.preventDefault();
    if (this.refs.cbPDF.state.switched) {
    //   this.downloadAsPdf(false);
    	downloadAsPdf.call(this, getUrlParameterByName("nav") ? getUrlParameterByName("nav") : "map");
    }

    if (this.refs.cbCSV.state.switched) {
			// const nav = getUrlParameterByName('nav') || 'overview';
			// if (nav === 'overview') {
	  //     this.handleCsvDownload();
   //    } else {
      	createCsvFile.call(this);
      // }
    }
	}

	downloadTopAsPdf(isPageVisit) {
		this.setState({showLoadingDialog: true})

		const {selected_client, client_sites, websiteId, clients, dayRange} = this.props
		let c = clients.find(function(client){
			return parseInt(client.id, 10) === parseInt(selected_client, 10)
		})
		if (!c){
			clients.forEach(function(cl){
				if (cl.businessUnits){
					cl.businessUnits.forEach(function(b){
						if (parseInt(b.id, 10) === parseInt(selected_client, 10))
							c = b
					})
				}
			})
		}

		const clientName = c && c.name ? c.name : ""
		const s = client_sites.find(function(site){
			return site.value === websiteId
		})

		const fileName = clientName + '_insights_top_attributes_' + dayRange.replace(/-/g, '_') + '_' +
			moment().format('YYYYMMDD') + '.pdf'

		const pdf = new pdfConverter('p', 'mm', 'a4')
		pdf.setFont("helvetica")
		pdf.setFontType("normal")
		pdf.setFontSize(9)
		const pageWidth = 186

		const el_demogrphic = document.getElementsByClassName("top-demographics")[0];
		const el_behavior = document.getElementsByClassName("top-behaviors")[0];

		let canvasDemographic = null;
		let canvasBehavor = null;
		let isDemogrphicReady = false;
		let isBehaviorReady = false;
		const oriWidth = el_demogrphic.offsetWidth;
		el_demogrphic.style.width = "1024px";
		setTimeout(function () {
			html2canvas(el_demogrphic, {logging:false}).then(function (canvas) {
				canvasDemographic = canvas
				isDemogrphicReady = true
				el_demogrphic.style.width = oriWidth + 'px'
			 })
		}, 50);

		el_behavior.style.width = "1024px";
		setTimeout(function () {
			html2canvas(el_behavior, {logging:false}).then(function (canvas) {
				canvasBehavor = canvas
				isBehaviorReady = true
				el_behavior.style.width = oriWidth + 'px'
			 })
		}, 50);

		let top = 10
		let intervalId = setInterval(function () {
			if ((isDemogrphicReady === false) || (isBehaviorReady === false)){
				console.log('PDF generating...')
			}else{
				clearInterval(intervalId);
				setTimeout(function(){
					pdf.setFillColor(127,127,127);
					pdf.rect(0, 15 , 210, 10, 'F');
					pdf.setTextColor(0, 0, 0)
					pdf.setFontSize(9)
					pdf.setFontType('bold')
					pdf.addImage(pdfReportHeaderDataUri(), 'PNG', 10.5, 3, 60, 0)
					pdf.text(198, 8, moment().format('MMMM DD, YYYY'), null, null, 'right');
					pdf.setTextColor(255,255,255)
					pdf.setFontType('bold')
					pdf.text(12, 19, 'Client:')
					const lenClientName = getTextSize(clientName.trim(), 'helvetica')
					pdf.setFontType('normal')
					pdf.text(23, 19, clientName.trim())
					//cm to inches
					let start = 23 + lenClientName.width * 0.3937 + 0.4
					pdf.setFontType('bold')
					pdf.text(start, 19, 'WEBSITE NAME:')
					start += 26.5
					pdf.setFontType('normal')
					pdf.text(start, 19, s && s.label ? s.label.trim() : '')
					start += s && s.label ? (getTextSize(s.label.trim(), 'helvetica')).width * 0.3937 + 0.4 : 1
					pdf.setFontType('bold')
					pdf.text(start, 19, 'Date:')
					pdf.setFontType('normal')
					start += (getTextSize('Date:', 'helvetica')).width * 0.3937 + 0.4
					pdf.text(start, 19, this.getDayRangeTitle(dayRange))

					pdf.setFillColor(255)
					pdf.setLineWidth(0.05)
					//pdf.line(0, isPageVisit ? 32 : 27, 210, isPageVisit ? 32 : 27)
					//pdf.line(0, isPageVisit ? 27: 22, 210, isPageVisit ? 27: 22)
					//top = isPageVisit ? 37 : 32
					top = isPageVisit ? 32 : 27;

					pdf.addImage(canvasDemographic.toDataURL(), 'PNG', 12, top, pageWidth, 0)
					const h1 = canvasDemographic.height * pageWidth / canvasDemographic.width
					//pdf.line(123, top+2, 123, top + h1 - 2)
					//top += h1 + 5
					top += h1 + 3.5
					pdf.addImage(canvasBehavor.toDataURL(), 'PNG', 12, top, pageWidth, 0)
					addPdfFooter(pdf);
					pdf.save(fileName)
					this.setState({showLoadingDialog: false})

				}.bind(this), 100)
			}
		}.bind(this), 50)
	}

	downloadCsvReport(isPageVisit) {
		this.setState({showLoadingDialog: true})

		const {selected_client, client_sites, websiteId, clients, dayRange} = this.props
		let c = clients.find(function(client){
			return parseInt(client.id, 10) === parseInt(selected_client, 10)
		})
		if (!c){
			clients.forEach(function(cl){
				if (cl.businessUnits){
					cl.businessUnits.forEach(function(b){
						if (parseInt(b.id, 10) === parseInt(selected_client, 10))
							c = b
					})
				}
			})
		}

		const clientName = c && c.name ? c.name : ""
		const s = client_sites.find(function(site){
			return site.value === websiteId
		})

		const fileName = clientName + '_insights_' + dayRange.replace(/-/g, '_') + '_' +
			moment().format('YYYYMMDD') + '.pdf'

		const pdf = new pdfConverter('p', 'mm', 'a4')
		pdf.setFont("helvetica")
		pdf.setFontType("normal")
		pdf.setFontSize(9)
		const pageWidth = 186

		let els = document.getElementsByClassName("total-visit-section")
		let totalVisitsCanva = null,
			demoGeoCanva = null,
			timeTrafficCanva = null,
			timeDeviceCanva = null,
			mostPopularCanva = null

		let isTotalVisitReady = false
		if (els.length > 0){
			const el = els[0]
			const tvWidth = el.offsetWidth
			el.style.width = '1024px'
			document.getElementById("cs_contact_form").style.display = "none";
			const colHeight = document.getElementById("visits_overview_col1").style.height;
			if (this.props.reportType === "consumer")
				document.getElementById("visits_overview_col1").style.height = "170px"
			else
				document.getElementById("visits_overview_col1").style.height = "auto"
      setTimeout(function () {
        html2canvas(el, {logging:false}).then(function (canvas) {
					totalVisitsCanva = canvas
					isTotalVisitReady = true
					el.style.width = tvWidth + 'px'
					document.getElementById("cs_contact_form").style.display = "block";
					document.getElementById("visits_overview_col1").style.height = colHeight;
			 	})
      }, 50);
		}
		els = document.getElementsByClassName("demo-geo-section")
		let isDemoGeoReady = false
		if (els.length > 0){
			const el = els[0]
/*
			if (isPageVisit){
				el.classList.remove("p-10")
				el.classList.remove("mt-10")
				el.classList.add("no-padding")
				const e1_width = el.children[0].offsetWidth
				const e2_width = el.children[1].offsetWidth
				const tdWidth = el.offsetWidth
				el.style.width = '1024px'
				el.children[0].style.width = '502px'
				el.children[1].style.width = '502px'
				setTimeout(function () {
					html2canvas(el,{logging:false}).then(function (canva) {
						demoGeoCanva = canva
						isDemoGeoReady = true
						el.children[0].style.width = e1_width + 'px'
						el.children[1].style.width = e2_width + 'px'
						el.style.width = tdWidth + 'px'
						el.classList.add("p-10")
						el.classList.add("mt-10")
						el.classList.remove("no-padding")
					})
				}, 50)
			}else{*/
				el.children[0].style['min-height'] = 'inherit'
				const dgWidth = el.offsetWidth
				el.style.width = '1024px'
				setTimeout(function () {
					html2canvas(el, {logging:false}).then(function (canva) {
						demoGeoCanva = canva
						isDemoGeoReady = true
						el.children[0].style['min-height'] = '250px'
						el.style.width = dgWidth + 'px'
					})
				}, 50);
			//}
		}
		els = document.getElementsByClassName("time-device-section")
		let isTimeDeviceReady = false
		if (els.length > 0){
			const el = els[0]
			el.classList.remove("p-10")
			el.classList.remove("mt-10")
			el.classList.add("no-padding")
			const tdWidth = el.offsetWidth
			el.style.width = '1024px'
			el.children[0].style.width = '50%'
			el.children[1].style.width = '50%'
      setTimeout(function () {
        html2canvas(el,{logging:false}).then(function (canva) {
					timeDeviceCanva = canva
					isTimeDeviceReady = true
					el.children[0].style.width = '50%'//e2_width + 'px'
					el.children[1].style.width = '50%'//e2_width + 'px'
					el.style.width = tdWidth + 'px'
					el.classList.add("p-10")
					el.classList.add("mt-10")
					el.classList.remove("no-padding")
				})
      }, 50)
		}
		els = document.getElementsByClassName("time-traffic-section")
		let isTimeTrafficeReady = false
		if (els.length > 0){
			const el = els[0]
			const ttWidth = el.offsetWidth
			el.style.width = '1024px'
      setTimeout(function () {
        html2canvas(el,{logging:false}).then(function (canvas) {
						timeTrafficCanva = canvas
						isTimeTrafficeReady = true
						el.style.width = ttWidth + 'px'
					})
      }, 100);
		}
		els = document.getElementsByClassName("most-popular-section")
		let isMostPopularReady = isPageVisit ? true : false
		if (els.length > 0 && (!isPageVisit)){
			const el = els[0]
			const mpWidth = el.offsetWidth
			const w1 = el.children[0].offsetWidth
			el.children[0].style.width = '502px'
			el.style.width = '1024px'
			el.classList.remove("pl-10")
			el.classList.add("no-padding-left")
      setTimeout(function () {
        html2canvas(el,{logging:false}).then(function (canva) {
					mostPopularCanva = canva
					isMostPopularReady = true
					el.classList.add("pl-10")
					el.classList.remove("no-padding-left")
					el.children[0].style.width = w1 + 'px'
					el.style.width = mpWidth + 'px'
				})
      }, 50);
		}
		let top = 10
		const url = new URL(window.location.href)
		const page = url.searchParams.get("p")
		let intervalId = setInterval(function () {
			if ((isDemoGeoReady === false) || (isTotalVisitReady === false) || (isTimeDeviceReady === false)
					|| (isTimeTrafficeReady === false) || (isMostPopularReady === false)){
				console.log('PDF generating...')
			}else{
				clearInterval(intervalId)
				//pdf.setDrawColor(0, 123, 99)
				setTimeout(function(){
					pdf.setFillColor(127,127,127);
					pdf.rect(0, 15 , 210, 10, 'F');

					pdf.setTextColor(0, 0, 0)
					pdf.setFontSize(9)
					pdf.setFontType('bold')
					pdf.addImage(pdfReportHeaderDataUri(), 'PNG', 10.5, 3, 60, 0)
					pdf.text(198, 8, moment().format('MMMM DD, YYYY'), null, null, 'right');

					pdf.setTextColor(255, 255, 255)
					pdf.setFontType('bold')
					pdf.text(12, 19, 'Client:')
					const lenClientName = getTextSize(clientName.trim(), 'helvetica')
					pdf.setFontType('normal')
					pdf.text(23, 19, clientName.trim())
					//cm to inches
					let start = 23 + lenClientName.width * 0.3937 + 0.4
					pdf.setFontType('bold')
					pdf.text(start, 19, 'WEBSITE NAME:')
					start += 26.5
					pdf.setFontType('normal')
					pdf.text(start, 19, s && s.label ? s.label.trim() : '')
					start += s && s.label ? (getTextSize(s.label.trim(), 'helvetica')).width * 0.3937 + 0.4 : 1
					pdf.setFontType('bold')
					pdf.text(start, 19, 'Date:')
					pdf.setFontType('normal')
					start += (getTextSize('Date:', 'helvetica')).width * 0.3937 + 0.4
					pdf.text(start, 19, this.getDayRangeTitle(dayRange))
					if (isPageVisit){
						pdf.setFontType('bold')
						pdf.text(12, 24, `Page:`)
						pdf.setFontType('normal')
						pdf.text(22, 24, page)
					}

					pdf.setFillColor(255)
					pdf.setLineWidth(0.05)
					//pdf.line(0, isPageVisit ? 32 : 27, 210, isPageVisit ? 32 : 27)
					//pdf.line(0, isPageVisit ? 27: 22, 210, isPageVisit ? 27: 22)
					//top = isPageVisit ? 37 : 32
					top = isPageVisit ? 32 : 27;

					pdf.addImage(totalVisitsCanva.toDataURL(), 'PNG', 12, top, pageWidth, 0)
					pdf.setLineWidth(0.03)
					const h1 = totalVisitsCanva.height * pageWidth / totalVisitsCanva.width
					//pdf.line(123, top+2, 123, top + h1 - 2)
					//top += h1 + 5
					top += h1 + 3.5
					pdf.addImage(demoGeoCanva.toDataURL(), 'PNG', 12, top, pageWidth, 0)
					const h2 = demoGeoCanva.height * pageWidth / demoGeoCanva.width
					pdf.setLineWidth(0.1)
					//pdf.line(92, top+2, 92, top + h2 - 2)
					//pdf.line(15.5, top + h2 - 5, 88, top + h2 - 5)
					//pdf.line(95, top + h2 - 5, 147, top + h2 -5)
					top += h2 + 5

					pdf.addImage(timeDeviceCanva.toDataURL(), 'PNG', 12, top, pageWidth, 0)
					pdf.setLineWidth(0.1)
					//pdf.line(15.5, top + h3 - 5.5, 59, top + h3 - 5.5)
					//pdf.line(110.5, top + h3 - 5.5, 154, top + h3 - 5.5)

					top += timeDeviceCanva.height * pageWidth / timeDeviceCanva.width + 5

					const imgHeight = timeTrafficCanva.height * pageWidth / timeTrafficCanva.width
					pdf.addImage(timeTrafficCanva.toDataURL(), 'PNG', 12, top, pageWidth, 0)
					top += imgHeight + 3

					if (!isPageVisit)
						pdf.addImage(mostPopularCanva.toDataURL(), 'PNG', 12, top, pageWidth, 0)
					//top += mostPopularCanva.height * pageWidth / mostPopularCanva.width + 5

					addPdfFooter(pdf);
					pdf.save(fileName)
					/*
					setTimeout(function(){
						map(listChartFooters, function(el){
							el.style['display'] = 'block'
						})
					}, 8000)*/
					this.setState({showLoadingDialog: false})
				}.bind(this), 100)
			}
		}.bind(this), 50)
	}

	getDayRangeTitle(key){

		switch (key) {
			case 'today':
				return "Today"
			case 'yesterday':
				return "Yesterday"
			case 'last-7-days':
				return 'Last 7 Days'
			case 'last-30-days':
				return 'Last 30 Days'
			case 'last-60-days':
				return 'Last 60 Days'
			case 'last-90-days':
				return 'Last 90 days'
			default:
				return ''
		}
	}

	handleDownloadBtn() {
		const nav = getUrlParameterByName('nav') || 'overview';
		const popUrl = getUrlParameterByName('pop_url');
		const reportType = this.props.reportType;
		if (reportType !== 'business') {
			return () => this.setState({ showDownloadDialog: true });
		} else {
			if (nav === 'overview' || (nav === 'pop' && popUrl)) {
				return () => this.setState({ showDownloadDialog: true });
			}
		}
		return null;
	}

	cbPDFChange(e, isInputChecked) {
    const result = (!this.refs.cbCSV.state.switched) && (!isInputChecked);
    this.setState({disabledBtnDownload: result});
  }

  cbCSVChange(e, isInputChecked) {
    const result = !this.refs.cbPDF.state.switched && !isInputChecked;
    this.setState({ disabledDlBtn: result });
  }

	render() {
		const { location, statsByDevice, statsByTime, statsByRegionalTraffic, statsByPopularPages, top20FrequencyBusinesses,
			statsByDemographic, client_sites, statsByTimeOfDay, domesticVisitsSummary, domesticBusinessVisitsReport,
			websiteId, statsTopAttributes, dayRange, heatMapPoints, loadingDomesticVisitsSummary, client_info,
			loadingStatsByDemographic, loadingStatsByDeviceType, loadingStatsByTime, kindOfReport,
			loadingStatsByPopularPage, loadingStatsByRegionalTraffic, loadingStatsByTimeOfDay,
			loadingStatsTopAttributes, loadingStatsByPrimaryDevices, statsByDeviceModel,
			statsByOsType, states } = this.props;
		const dataOnLoading = loadingDomesticVisitsSummary || loadingStatsByDemographic || loadingStatsByDeviceType
			|| loadingStatsByTime || loadingStatsByPopularPage || loadingStatsByRegionalTraffic ||
			loadingStatsByTimeOfDay || loadingStatsTopAttributes || loadingStatsByPrimaryDevices;
		const { pathname, search } = location
		const isPageVisit = (pathname === '/insights/page-visits' ||
			(search.indexOf("type=pop-pages") >= 0) || (search.indexOf("tag=page") >= 0) || (search.indexOf("p=") >= 0))
		if (isEmpty(client_sites)) {
			return (
				<div id="website-visits-container">
					<div style={{ padding: '0 10%', marginTop: "-20px", marginBottom: "-10px"}}>
						<SiteDateSelector type="larger" key={'map-site-date-selector-' + new Date().getTime()}
							websiteIdChanged={this.props.setWebsiteId}
							siteId={websiteId} sites={this.props.client_sites} dayRangeChanged={this.props.setDateRange} dayRange={this.props.dayRange} />
					</div>
					<InsightNavigation />
					<div className="website-visits-content">
						<div style={{ width: '100%', minHeight: '280px', textAlign: 'center', paddingTop: '150px', color: "#CDCDCD" }}>
							<div style={{ color: "#CDCDCD", fontSize: '28pt', opacity: '0.8' }}>No Data</div>
						</div>
					</div>
				</div>
			)
		}

		const url = new URL(window.location.href)
		const page = url.searchParams.get("p")
		const nav = getUrlParameterByName('nav') || 'overview';
		const popUrl = getUrlParameterByName('pop_url');

		let sendRequestSource = ""
		if (this.props.reportType === "consumer") {
			if (popUrl)
				sendRequestSource = "Consumer > Most Popular Pages > " + popUrl;
			else{
				sendRequestSource = nav === "pop" ? "Consumer most popular page" : "Consumer " + nav + " page";
			}
		}
		if (this.props.reportType === "business") {
			if (nav === "pop") {
				if (popUrl)
					sendRequestSource = "Business > Most Popular Pages > " + popUrl;
				else
					sendRequestSource = "Business > Most Popular Pages"
			}
			else
				sendRequestSource = kindOfReport === "map" ? "Business > Geographic Traffic " : "Business overview page";
		}
		const visitDevices = statsByDevice ? [] : undefined
		const timeTraffic = statsByTime ? [] : undefined
		const popularPages = (statsByPopularPages) ? [] : undefined
		const visitsByTime = statsByTimeOfDay ? [] : undefined
		let geoTrafficeData = isEmpty(states) ? undefined : [];
		const heatMapData = []

		const addPercentSign = (val) => {
			return val.toFixed(2) + '%'
		}

		//const demoData = statsByDemographic ? [] : undefined
		let demoData = undefined
		if ((this.props.reportType === "consumer")) {
			if (statsByDemographic) {
				demoData = []
				map(statsByDemographic, (stat, key) => {
					if (key === 'maritalStats')
						return
					const title = getDemographicText(key.replace("Stats", ""))
					let valText = ''
					if (Array.isArray(stat)) {
						if (stat.length > 1) {
							stat.forEach(function (item) {
								switch (key) {
									case "genderStats":
										/*if (item.key !== 'U')
											valText += addPercentSign(item.value * 100) + ' (' + item.key + ') - '
										*/
										if (isEmpty(valText))
											valText = addPercentSign(item.value * 100) + ' (' + item.key + ') - '
										break;
									case "maritalStats":
										/*
										if (item.key === 'M')
											valText += addPercentSign(item.value * 100) + '  '*/
										break
									default:
										valText += addPercentSign(item.value * 100) + ' (' + item.key + ') - '
								}
							})
							valText = valText.substring(0, valText.length - 2)
						} else {
							valText = key === stat.length > 0 ? 'genderStats' ? addPercentSign(stat[0].value * 100) + ' (' + stat[0].key + ')' : addPercentSign(stat[0].value * 100) : ""
						}
					} else {
						switch (key) {
							case 'medianAge':
								valText = Math.round(stat) + ''
								break
							case 'medianNumberOfPeople':
								valText = Math.round(stat * 10) / 10 + ''
								break
							case 'medianIncome':
								valText = '$' + splitNumber(Math.round(stat))()
								break;
							default:
								valText = stat + ''
						}
					}
					if ((valText === "0") || (isEmpty(valText)) || (valText === 'null') || (valText === "$0")){
						valText = 'UnKnown'
						if (this.props.client_sites && Array.isArray(this.props.client_sites) && this.props.client_sites.length > 0){
							const site_name = this.props.client_sites[0].label
							if (site_name === 'Auto Inc.'){
								switch (key) {
									case 'medianAge':
										valText = '50'
										break
									case 'medianNumberOfPeople':
										valText = '2.3'
										break
									case 'medianIncome':
										valText = '$' + splitNumber(47965)()
										break
									case 'homeOwnershipStats':
										valText = '52.56%'
										break
									case 'genderStats':
										valText = '46.30% (M)'
										break
									default:
										valText = ''
								}
							}
						}
					}
					demoData.push({ name: title, value: valText })
				})
			}
		} else {
			if (domesticBusinessVisitsReport) {
				demoData = [
					{name:"Top Industry", value:"Unknown"},
					{name:"Average Annual Company Revenue", value:'Unknown'},
					{name:"Average Number of Company Employees", value:'Unknown'},
					{name:"Average Age of Business", value:"Unknown"},
					{name:"Home Business", value:"Unknown"}
				]
				map(domesticBusinessVisitsReport, (stats, key) => {
					let title = "";
					let valText = "";
					switch (key) {
						case 'totalVisits':
						case 'uniqueVisits':
							title = 'Unique Business Visits'
							valText = splitNumber(stats)();
							break;
						case 'topIndustry':
							title = 'Top Industry';
							valText = stats;
							break;
						case 'averageBizAge':
							title = 'Average Age of Business';
							valText = stats ? stats.toFixed(2) + " years" : "";
							break;
						case 'averageEmployees':
							title = 'Average Number of Company Employees'
							valText = stats ? isNaN(stats) ? "N/A" : splitNumber(parseInt(stats, 10))(): "N/A";
							break;
						case 'averageRevenue':
							title = 'Average Annual Company Revenue';
							valText = stats ? isNaN(stats) ? "N/A" : "$" + splitNumber(stats)() : "N/A";
							break;
						case 'homeBizPercentage':
							title = "Home Business";
							valText = stats === 0 ? "Unknown" : addPercentSign(stats * 100)
							break;
						default:
							title =  "";
					}
					if ((valText === "0") || (isEmpty(valText)))
						valText = "Unknown";
					const idx = findIndex(demoData, {name: title});
					if (idx >= 0)
						demoData.splice(idx, 1, {name: title, value: valText});
				})
			}
		}


		if (statsByTimeOfDay) {
			map(statsByTimeOfDay.stats, (stat) => {
				visitsByTime.push({
					name: stat.type,
					value: stat.uniquePercentage * 100,
					uniqueVisits: stat.unique
				})
			})
		}
		let visitsSummary = undefined
		if (domesticVisitsSummary) {
			visitsSummary = {
				totalVisitsCount: 0,
				uniqueVisitsCount: 0,
				reachStats: {}
			}

			visitsSummary.totalVisitsCount = domesticVisitsSummary.totalVisits;
			visitsSummary.uniqueVisitsCount = domesticVisitsSummary.uniqueVisits;
			visitsSummary.reachStats = domesticVisitsSummary.reachStats;
		}

		if (statsByDevice){
			map(statsByDevice.stats, (obj) => {
				const device = { name: obj.type, value: obj.uniquePercentage * 100, uniqueVisits: obj.unique }
				visitDevices.push(device)
			})
		}

		let timeTrafficStatsTitle = ''
		timeTrafficStatsTitle = '' + this.getDayRangeTitle(dayRange)

		if (statsByTime) {
			map(statsByTime.stats, (obj) => {
				let timeStr = ''
				switch (dayRange) {
					case 'yesterday':
					case 'today':
						timeStr = moment(obj.type).format("hA")
						break
					default:
						timeStr = moment(obj.type, 'YYYY-MM-DD').format("MMM-DD")
				}
				const item = { time: timeStr, totalVisits: obj.total, uniqueVisits: obj.unique }
				timeTraffic.push(item)
			})
		}
		if (states && (!isEmpty(states))) {
			const values = states
			const sum = reduce(
				values,
				function(sum, d) {
					return sum + d.unique;
				},
				0,
			);
			map(values, (obj) => {
				geoTrafficeData.push({
					name: obj.type,
					value: obj.unique / sum * 100,
					uniqueVisits: obj.unique
				})
			})
			geoTrafficeData = sortBy(geoTrafficeData, "value").reverse();
		}
		if (heatMapPoints){
			map(heatMapPoints, (point) => {
				heatMapData.push({
					position: [point.lon, point.lat],
					weight: parseInt(point.u, 10)
				})
			})
		}

		if (statsByPopularPages) {
			map(statsByPopularPages, (stat) => {
				popularPages.push({
					name: stat.pageUrl,
					value: stat.totalVisits
				})
			})
		}

		if (kindOfReport === "popular"){
			if (isNil(popularPages)){
				return (
					<div id="website-visits-container">
						<div style={{ padding: '0 10%', marginTop: "-20px", marginBottom: "-10px" }}>
							<SiteDateSelector type="larger" key={'top-pages-date-selector-' + new Date().getTime()} websiteIdChanged={this.props.setWebsiteId}
								siteId={websiteId} sites={this.props.client_sites} dayRangeChanged={this.props.setDateRange} dayRange={this.props.dayRange} />
						</div>
						<InsightNavigation activeIndex={isPageVisit ? 1 : 0}
							clientId={this.props.selected_client} tagId={this.props.websiteId} />
						<div className="website-visits-content">
							<img alt="" src="/Spinner.gif" style={{ height: "24px" }} />&nbsp;loading...
						</div>
					</div>
				)
			}else{
				return (
					<div id="website-visits-container">
						<div style={{ padding: '0 10%', marginTop: "-20px", marginBottom: "-10px" }}>
							<SiteDateSelector  type="larger" key={'top-page-date-selector-' + new Date().getTime()} websiteIdChanged={this.props.setWebsiteId}
								siteId={websiteId} sites={this.props.client_sites} dayRangeChanged={this.props.setDateRange} dayRange={this.props.dayRange} />
						</div>
						<InsightNavigation activeIndex={isPageVisit ? 1 : 0}
							clientId={this.props.selected_client} tagId={this.props.websiteId} />
						<div className="website-visits-content">
							<FullRow className="no-padding mb-20 no-margin-top">
								<InsightBreadcrumb src={this.props.reportType} clientId={this.props.selected_client}
									tagId={this.props.websiteId} kindOfReport={this.props.kindOfReport} />
							</FullRow>
							<div className="black-border pb-10 bg-white">
								<PopularPageListSection key="" title="MOST POPULAR PAGES" reportType={this.props.reportType}
									subTitle="Total Visits" data={popularPages} tier={client_info.subscriptionTierId} />
							</div>
						</div>
					</div>
				)
			}
		}
		let navFirEle = <div className="nav-frequents" style={{height:'300px',display:'flex',alignItems:'center',justifyContent:'center'}}>
				<img alt="" src="/Spinner.gif" style={{ height: "24px" }} />&nbsp;loading...
			</div>;
		if (top20FrequencyBusinesses) {
			navFirEle = (<div className="light-grey-border no-padding-bottom">
					<FrequencyVisitorList key="freq-visitors-container" title="Top 20 Companies that have Visited"
						data={top20FrequencyBusinesses} />
				</div>);
		}

		if (kindOfReport === "frequents") {
			if (isUndefined(top20FrequencyBusinesses)) {
				return (
					<div id="website-visits-container">
						<div style={{ padding: '0 10%', marginTop: "-20px", marginBottom: "-10px" }}>
							<SiteDateSelector key={'top-pages-date-selector-' + new Date().getTime()} websiteIdChanged={this.props.setWebsiteId}
								siteId={websiteId} sites={this.props.client_sites} dayRangeChanged={this.props.setDateRange} dayRange={this.props.dayRange} />
						</div>
						<InsightNavigation activeIndex={isPageVisit ? 1 : 0}
							clientId={this.props.selected_client} tagId={this.props.websiteId}/>
						<div className="website-visits-content">
							<img alt="" src="/Spinner.gif" style={{ height: "24px" }} />&nbsp;loading...
						</div>
					</div>
				)
			}
			if (top20FrequencyBusinesses) {
				return (
					<div id="website-visits-container">
						<BasicTierUpgradeInform
							showUpgradeInfoDialog={Boolean(this.state.showUpgradeInfoDialog)}
							onContactFormSubmit={this.props.sendAssistRequest.bind(this)}
							send_assist_request_error={this.props.send_assist_request_error}
							selected_client={this.props.selected_client}
							request_assist_successful={this.props.request_assist_successful}
							type={this.props.reportType}
							roleId={this.props.roleId}
							originationPage={this.props.reportType === "consumer" ? "Main Consumer Insights Dashboard - Static Page" :
							"Main Business Insights Dashboard - Static Page"}
							history={this.props.history}
							closeDialog={() => this.props.history.push("/insights/" + this.props.reportType +"?cid="+this.props.selected_client)} />
						<div style={{ padding: '0 10%', marginTop: "-20px", marginBottom: "-10px" }}>
							<SiteDateSelector key={'top-page-date-selector-' + new Date().getTime()}
								websiteIdChanged={this.props.setWebsiteId}
								siteId={websiteId} sites={this.props.client_sites}
								dayRangeChanged={this.props.setDateRange}
								dayRange={this.props.dayRange} />
						</div>
						<InsightNavigation activeIndex={isPageVisit ? 1 : 0}
							clientId={this.props.selected_client} tagId={this.props.websiteId} />
						<div className="website-visits-content">
							<FullRow className="no-padding mb-20 no-margin-top">
								<InsightBreadcrumb src={this.props.reportType} clientId={this.props.selected_client}
									tagId={this.props.websiteId} kindOfReport={this.props.kindOfReport} />
							</FullRow>
							<div className="light-grey-border no-padding-bottom" style={{minWidth:"1000px"}}>
								<FrequencyVisitorList key="freq-visitors-container" title="TOP 20 COMPANIES THAT HAVE VISITED"
									data={top20FrequencyBusinesses} />
							</div>
						</div>
					</div>
				)
			}
		}
		const formatAddDemoData = () => {
			const { demographic, behavioral } = statsTopAttributes
			const demoDatas = []
			map(orderBy(demographic, ['visitorPercentage'], ['desc']), (item) => {
				demoDatas.push({
					name: item.name,
					value: item.label,
					visits: item.visitorPercentage
				})
			})

			const behavioralDatas = []
			map(orderBy(behavioral, ['visitorPercentage'], ['desc']), (item) => {
				behavioralDatas.push({
					name: item.name,
					value: item.label,
					visits: item.visitorPercentage
				})
			})
			return [demoDatas, behavioralDatas];
		};
		if (kindOfReport === "top") {
			if (!statsTopAttributes) {
				return (
					<div id="website-visits-container">
						<div style={{ padding: '0 10%', marginTop: "-20px", marginBottom: "-10px" }}>
							<SiteDateSelector key={'top-pages-date-selector-' + new Date().getTime()} websiteIdChanged={this.props.setWebsiteId}
								siteId={websiteId} sites={this.props.client_sites} dayRangeChanged={this.props.setDateRange} dayRange={this.props.dayRange} />
						</div>
						<InsightNavigation activeIndex={isPageVisit ? 1 : 0}
							clientId={this.props.selected_client} tagId={this.props.websiteId}/>
						<div className="website-visits-content">
							<img alt="" src="/Spinner.gif" style={{ height: "24px" }} />&nbsp;loading...
						</div>
					</div>
				)
			}

			const [demoDatas, behavioralDatas] = formatAddDemoData();

			return (
				<div id="website-visits-container">

				<Dialog open={this.state.showLoadingDialog || (!!dataOnLoading)}
					style={{top: '-1.8em'}}
					overlayStyle={{opacity: 0.9, backgroundColor:'#666666'}}
					modal={true}>
					<Row className="mt-20">
						<Col xs="7" sm="7" md="7" lg="6" className="text-right">
							<div>{ dataOnLoading ? "Data loading, please wait..." : "Downloading, please wait..."}</div>
						</Col>
						<Col xs="2" sm="2" md="2" lg="2">
							<img alt="" src="/Spinner.gif" style={{ height: "24px" }} />
						</Col>
					</Row>
				</Dialog>
					<div style={{ padding: '0 10%', marginTop: "-20px", marginBottom: "-10px", background: "#FAFAFA" }}>
						<SiteDateSelector key={'top-page-date-selector-' + new Date().getTime()}
							showGranularity={true}
							websiteIdChanged={this.props.setWebsiteId}
							siteId={websiteId} sites={this.props.client_sites}
							downloadBtnText="Download Report"
							dayRangeChanged={this.props.setDateRange}
							dayRange={this.props.dayRange}
							granularity={this.props.granularity}
							granularityChanged={this.props.setGranularity}
						/>
					</div>
					<InsightNavigation activeIndex={isPageVisit ? 1 : 0}
						clientId={this.props.selected_client} tagId={this.props.websiteId} />
					<div className="website-visits-content">
						<div className="no-padding mb-20 no-margin-top">
							<InsightBreadcrumb src={this.props.reportType} clientId={this.props.selected_client}
									tagId={this.props.websiteId} kindOfReport={this.props.kindOfReport} />
						</div>
						<div className="black-border no-padding-bottom top-demographics">
							<TopAttributeListSection key="" title="TOP DEMOGRAPHIC / HOUSEHOLD ATTRIBUTES"
								subTitle="Unique Visits" data={demoDatas} />
						</div>
						<div className="black-border mt-20 no-padding-bottom top-behaviors">
							<TopAttributeListSection title="TOP BEHAVIORAL ATTRIBUTES"
								subTitle="Unique Visits" data={behavioralDatas} />
						</div>
					</div>
				</div>
			)
		}
		const reportType = this.props.reportType;
		const showGranularity = false;
		return (
			<div id="website-visits-container">
				<Dialog open={this.state.showLoadingDialog || (!!dataOnLoading)}
					style={{top: '-1.8em'}}
					overlayStyle={{opacity: 0.9, backgroundColor:'#666666'}}
					modal={true}>
					<Row className="mt-20">
						<Col xs="6" sm="6" md="6" lg="6" className="text-right">
							<div>{ dataOnLoading ? "Data loading, please wait..." : "Downloading, please wait..."}</div>
						</Col>
						<Col xs="2" sm="2" md="2" lg="2">
							<img alt="" src="/Spinner.gif" style={{ height: "24px" }} />
						</Col>
					</Row>
				</Dialog>
				{
					((nav && nav !=="overview" && nav !=="demographics" && nav !== "device" && nav !== "pop") || (kindOfReport==="map") || ((kindOfReport === "frequents" || nav === 'fir'))) &&
					<BasicTierUpgradeInform
						showUpgradeInfoDialog={Boolean(this.state.showUpgradeInfoDialog)}
						onContactFormSubmit={this.props.sendAssistRequest.bind(this)}
						send_assist_request_error={this.props.send_assist_request_error}
						selected_client={this.props.selected_client}
						request_assist_successful={this.props.request_assist_successful}
						type={this.props.reportType}
						roleId={this.props.roleId}
						closeDialog={() => {
							this.props.history.push("/insights/" + this.props.reportType +"?cid="+this.props.selected_client);
						}}
						originationPage={this.props.reportType === "consumer" ? "Main Consumer Insights Dashboard - Static Page" :
							"Main Business Insights Dashboard - Static Page"}
					history={this.props.history} />
				}
				{showGranularity ? <div className="new-insight-navigator mb-20" style={{
					padding: '0 10% 20px',
					borderBottom: '1px solid #b1b0b0'
				}}>
					<NewNavigator siteId={websiteId} options={nav === 'overview' ? [
					{name: 'Insights', event: () => {
						this.props.history.push('/insights/summary?cid=' + this.props.selected_client);
					}},
		      {name: 'Site Analytics', event: () => {
						this.props.history.push('/insights/summary?cid=' + this.props.selected_client);
					}},
		      {name: 'Overview', event: undefined},
					] : [
					{name: 'Insights', event: () => {
						this.props.history.push('/insights/summary?cid=' + this.props.selected_client);
					}},
		      {name: 'Site Analytics', event: () => {
						this.props.history.push('/insights/summary?cid=' + this.props.selected_client);
					}},
					{name: 'Most Popular Pages', event: () => {
						this.props.history.push('/insights/consumer?nav=pop&cid=' + this.props.selected_client);
					}},
					{name: popUrl, event: undefined}
					]}/>
				</div> : null}
				<div style={{ padding: '0 10%', marginTop: "-20px", marginBottom: "-10px" }}>
					<SiteDateSelector
						type="larger"
						showGranularity={reportType === "consumer" && kindOfReport !== "map" && nav &&
							(nav === "overview" || (nav === "pop" && popUrl))}
						key={'web-stats-date-selector-' + new Date().getTime()}
						websiteIdChanged={this.props.setWebsiteId}
						siteId={websiteId} sites={this.props.client_sites}
						downloadBtnText="Download Report"
						handlePdfDownload={this.handleDownloadBtn()}
						dayRangeChanged={this.props.setDateRange} dayRange={this.props.dayRange}
						granularity={this.props.granularity}
						granularityChanged={this.props.setGranularity} />
				</div>
				<InsightNavigation activeIndex={isPageVisit ? 1 : 0}
					clientId={this.props.selected_client} tagId={this.props.websiteId}/>
				<div className="website-visits-content" >
					{(search.indexOf("type=") <0) && !showGranularity && <div className="no-padding mb-20 no-margin-top">
							<InsightBreadcrumb
							src={this.props.reportType}
							kindOfReport={this.props.kindOfReport}
							clientId={this.props.selected_client}
							tagId={this.props.websiteId}
							popUrl={popUrl}
							nav={nav}
							/>
					</div>}

					<div style={{display: "flex"}}>
						<SideBar
						type={nav ? nav : "overview"}
						history={this.props.history}
						clientId={this.props.selected_client}
						pageUrl={popUrl}
						reportType={this.props.reportType}/>
						<div className="ml-20" style={{flex:"1 1"}}>
						<div className="overview-insights-container" id="overview-dashboard" style={{ fontSize: "16px" }}>
								{
									((this.props.kindOfReport !== "map" && this.props.reportType !== "business" ) ||
										(this.props.reportType === "business" && nav === "pop")) && [
									<div key="1" id="consumer-overflow-pdf-part1"
										style={{
											background: "#F5F5F5",
											fontSize: "24px",
											fontWeight: "bold",
											padding: "15px 20px",
											marginBottom: '20px'
										}}
									>
										{this.props.reportType === 'business' ? 'Business' : 'Consumer'} Site Traffic
									</div>,
									<div key="2" id="service-contact" className={"mt-20 p-20 light-grey-border" + (this.props.reportType === 'business' && nav === 'pop' && popUrl ? ' mb-20' : '')} style={{display: 'block'}}>
										<div style={{ textAlign: "center" }}>
										<ServiceContact className="no-padding" sendAssistRequest={this.props.sendAssistRequest}
											style={{fontSize:'16px',textAlign:"center" }}
											messageText={this.props.reportType === 'business' && nav === 'pop' && popUrl && 'to engage and activate these audiences across online and offline channels.'}
											send_assist_request_error={this.props.send_assist_request_error}
											request_assist_successful={this.props.request_assist_successful}
											selected_client={this.props.selected_client} pageSource={sendRequestSource} />
										</div>
									</div>]
								}
								{
									(!nav || nav === 'overview') && this.props.reportType === 'business' &&
									<div className="mb-20 p-20 light-grey-border" id="service-contact" style={{display: 'block'}}>
										<div style={{ textAlign: "center" }}>
										<ServiceContact className="no-padding" sendAssistRequest={this.props.sendAssistRequest}
											style={{fontSize:'16px',textAlign:"center" }}
											messageText={'to engage and activate these audiences across online and offline channels.'}
											send_assist_request_error={this.props.send_assist_request_error}
											request_assist_successful={this.props.request_assist_successful}
											selected_client={this.props.selected_client} pageSource={sendRequestSource} />
										</div>
									</div>
								}
							{
								(!nav || nav==="overview" || (nav === 'pop' && popUrl)) &&
							<OverviewInsights
								visitsByTime={visitsByTime}
								geoTrafficeData={geoTrafficeData}
								timeTraffic={timeTraffic}
								timeTrafficStatsTitle={timeTrafficStatsTitle} visitsSummary={visitsSummary} kindOfReport={kindOfReport}
								selected_client={this.props.selected_client}
								heatMapData={heatMapData} loadingStatsByRegionalTraffic={loadingStatsByRegionalTraffic}
								reportType={this.props.reportType}
								deviceTypeData={statsByDevice}
								popUrl={popUrl}
								sendAssistRequest={this.props.sendAssistRequest}
								send_assist_request_error={this.props.send_assist_request_error}
								request_assist_successful={this.props.request_assist_successful}
								pageSource={sendRequestSource}
								statsByPopularPages={popularPages ? popularPages.slice(0, 5) : undefined}
								demoData={demoData}
								pdfCreating={this.state.pdfCreating}
								client_info={this.props.client_info}
								/>
							}
							{
								(nav && nav === "device" &&
									<DeviceInsights deviceTypeData={statsByDevice} deviceModelData={statsByDeviceModel}
									top5OSBreakDown={statsByOsType} />
								)
							}
							{
								(nav === "pop" && !popUrl) &&
									<MostPopularPageInsights
										data={statsByPopularPages}
										client_info={this.props.client_info}
									/>
							}
							{ nav === 'fir' && navFirEle }
							</div>
						</div>
					</div>
				</div>
        <Dialog
          open={!!this.state.showDownloadDialog}
          style={{ top: "-1.8em" }}
          modal={true}
          contentStyle={{ width: "440px" }}
        >
          <FullRow
            className="no-margin-top no-padding"
            style={{ fontSize: "16px", color: "#000" }}
          >
            <strong>Choose the type of file you would like to download</strong>
          </FullRow>
          <FullRow
            className="no-padding-top no-padding-right no-padding-bottom no-margin-bottom"
            style={{ paddingLeft: "150px" }}
          >
            <Checkbox
              iconStyle={{ fill: "#47A1AB", marginRight: "10px" }}
              label={"PDF File"}
							labelStyle={{ fontSize: "13px" }}
              defaultChecked={true}
              ref="cbPDF"
              onCheck={(e, isInputChecked) =>
                this.cbPDFChange(e, isInputChecked)
              }
            />
          </FullRow>
          <FullRow
            className="no-padding-top no-padding-right no-padding-bottom"
            style={{ paddingLeft: "150px" }}
          >
            <Checkbox
              iconStyle={{ fill: "#47A1AB", marginRight: "10px" }}
              label={"CSV File"}
              labelStyle={{ fontSize: "13px" }}
              defaultChecked={!((nav === 'pop' && !popUrl)) && this.props.reportType !== 'business'}
              disabled={(nav === 'pop' && !popUrl) || this.props.reportType === 'business'}
              ref="cbCSV"
              onCheck={(e, isInputChecked) =>
                this.cbCSVChange(e, isInputChecked)
              }
            />
          </FullRow>
          <FullRow className="no-padding no-margin-bottom mt-20 text-center">
            <button
              type="button"
              onClick={() => this.setState({ showDownloadDialog: false, disabledBtnDownload: false })}
              className="btn btn-default btn-aa-info mr-20"
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={this.handleDownload.bind(this)}
              disabled={
                this.state.disabledBtnDownload
              }
              className="btn btn-default btn-aa-default"
            >
              Download File
            </button>
          </FullRow>
        </Dialog>
			</div>
		)

	}
}

export default WebsiteVisits



// WEBPACK FOOTER //
// ./src/components/Insights/website/index.jsx